import { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router";

import Button from "@components/v2/buttons/Button";

type Props = Pick<ComponentProps<typeof Button>, "color" | "disabled" | "onClick" | "routerLink"> & {
  direction: "back" | "next";
};

const DirectionButton = ({ direction, ...buttonProps }: Props) => {
  const history = useHistory();

  const maybeOnClickProp: Pick<ComponentProps<typeof Button>, "onClick"> = {};
  if (!buttonProps.onClick && !buttonProps.routerLink) {
    maybeOnClickProp.onClick = direction === "back" ? history.goBack : history.goForward;
  }

  const directionText = direction === "back" ? "return" : direction;

  return (
    <Button fill="outline" {...maybeOnClickProp} {...buttonProps}>
      <FormattedMessage id={`dictionary.${directionText}`} />
    </Button>
  );
};

export default DirectionButton;
